import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/user-roles/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const userRoles = {
  getAll: apiPathFunc(pathBase),
} as const;
